import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  @Input() upperTitle: string = '';
  @Input() title: string = '';
  @Input() showButton: boolean = true;
  @Input() buttonText: string = '';
  @Input() buttonRedirectLink = '';

  constructor() {}

  ngOnInit(): void {}
}
